module.exports = __webpack_public_path__ + "img/loriot-callback.ba64eb06.png";